import { FacetedToolbar } from './FacetedToolbar.component';

export { FacetedToolbar };
